/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';
import Helmet from 'react-helmet';
import { Container, Row, Col, Button } from 'reactstrap';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import favicon from './img/complay1.ico';
import logo from './img/logo.png'
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'ComtecoPlay';
    document.body.style.backgroundColor = '#f2f2f2';
  });
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  return (
    <Container fluid={true} className="comt-body">
      <Helmet>
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      </Helmet>
      <Row className="comt-head">
        <Col sm="1" xs="1" md="1" style={{ padding: 0, zIndex: '9999' }}>
          <Button onClick={() => window.history.back()} className="comt-btn-back">
            <i class="fa fa-arrow-left fa-2x back"></i>
          </Button>
        </Col>
        <Col sm="12" xs="12" md="12" style={{ padding: 0, position: 'absolute' }}>
          <img src={logo} alt="logo" className="logo-comt rounded mx-auto d-block" />
        </Col>
      </Row>
      <Row style={{ margin: 0 }}>
        <Col>
          {
            _validateParams()
              ? <LoginForm
                api={api}
                location={location}
              />
              : <RequestLoginErrorMessage
                onlyMessage={true}
                message={translate('RequestLoginErrorMessage')}
              />
          }
        </Col>
      </Row>
      {/* </div> */}
      {/* </div> */}
    </Container>
  );
}

export default Login;
